import { createSlice } from '@reduxjs/toolkit';
export const bulkActionsSlice = createSlice({
  name: 'bulkActions',
  initialState: {
    allIds: [],
    selectedIds: [],
    selectedByQuery: false
  },
  reducers: {
    setAllIds: (state, action) => {
      state.allIds = action.payload;
    },
    select: (state, action) => {
      state.selectedIds.push(...action.payload);
    },
    deselect: (state, action) => {
      state.selectedIds = state.selectedIds.filter(id => !action.payload.includes(id));
      state.selectedByQuery = false;
    },
    selectByQuery: (state, action) => {
      state.selectedByQuery = true;
      state.selectedIds = [...new Set([...state.selectedIds, ...action.payload])];
    },
    clearSelection: state => {
      state.selectedIds = [];
      state.selectedByQuery = false;
    }
  }
});
export const {
  setAllIds,
  select,
  deselect,
  selectByQuery,
  clearSelection
} = bulkActionsSlice.actions;